import { SvgIcon } from '@mui/material';
import React from 'react';

const SCOTechnicalIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <path d="m74.14,60.39v19.37h-20.77c7.07-6.59,14.03-13.08,20.77-19.37Z" />
          <path d="m125.13,101.32v-38.91c0-2.39-2.02-4.32-4.51-4.32h-40.82c0,7.93,0,15.85,0,23.78,0,1.83-1.55,3.32-3.47,3.32-8.21,0-16.43,0-24.65,0v60.5c0,2.38,2.01,4.3,4.49,4.3h62.99c3.3,0,5.97-2.6,5.97-5.8v-42.87Zm-39.47-25.25c.54-1.16,1.54-1.66,2.86-1.65,3.72.01,7.43,0,11.15,0,3.69,0,7.37-.02,11.06,0,2.19.01,3.6,1.92,2.76,3.73-.54,1.16-1.54,1.66-2.86,1.65-3.9-.01-7.81,0-11.71,0-3.53,0-7.06.02-10.59-.01-2.12-.02-3.49-1.95-2.67-3.73Zm2.76,14.5c-2.19-.01-3.6-1.92-2.76-3.73.54-1.16,1.54-1.65,2.86-1.65,4,.01,8,0,11.99,0,3.44,0,6.87-.02,10.31.01,2.12.02,3.49,1.95,2.67,3.73-.54,1.16-1.54,1.65-2.86,1.65-3.72-.01-7.43,0-11.15,0-3.69,0-7.37.02-11.06,0Z" />
        </g>
        <path d="m159.96,98.86l-11.19-8.72c.94-4.11,1.48-8.37,1.48-12.75s-.54-8.66-1.48-12.78l11.2-8.73c3.65-2.84,4.52-7.84,2.05-11.66l-9.86-15.23c-2.48-3.83-7.54-5.3-11.82-3.43l-13.15,5.73c-5.42-4.18-11.6-7.47-18.29-9.73l-1.85-13.74c-.6-4.47-4.57-7.81-9.27-7.81h-18.71c-4.7,0-8.67,3.34-9.27,7.81l-1.85,13.73c-6.7,2.25-12.89,5.55-18.31,9.74l-13.14-5.72c-4.28-1.86-9.34-.39-11.82,3.43l-9.86,15.23c-2.48,3.83-1.6,8.82,2.05,11.66l11.2,8.73c-.95,4.12-1.48,8.39-1.48,12.78s.53,8.64,1.47,12.75l-11.19,8.72c-3.65,2.84-4.52,7.84-2.05,11.66l9.86,15.23c2.48,3.83,7.54,5.3,11.82,3.43l10.1-4.4v-23.17c-4.36-7.09-6.88-15.38-6.88-24.25,0-26.14,21.8-47.32,48.7-47.32s48.69,21.19,48.69,47.32c0,8.86-2.51,17.16-6.88,24.25v23.17l10.1,4.4c4.28,1.86,9.34.39,11.82-3.43l9.86-15.23c2.48-3.83,1.6-8.82-2.05-11.66Z" />
      </svg>
    </SvgIcon>
  );
};

export default SCOTechnicalIcon;
